import { UserActionType } from '../constants/userActionType';
import Backend from 'src/api/Backend';
import * as firebase from 'firebase';

export const signup = (formProps, callback) => async dispatch => {
    const { email, password, username } = formProps;
    console.log(email)
    try {
        const credential = await Backend.auth().createUserAndRetrieveDataWithEmailAndPassword(
            email,
            password
        );
let newUser
        console.log(credential)
        Backend.database()
            .ref('/users/' + credential.user.uid)
            .update({
                name: username,
                email: credential.user.email,
                photo: 'https://winkeyecare.com/wp-content/uploads/2013/03/Empty-Profile-Picture-450x450.jpg',
                uid: credential.user.uid,
                favorites: []
            })
            .then(() => {


                dispatch({
                    type: UserActionType.LOGIN,
                    payload: {
                        user: {

                            photo: 'https://winkeyecare.com/wp-content/uploads/2013/03/Empty-Profile-Picture-450x450.jpg',
                            name: username,
                            email: email,
                            uid: credential.user.uid,
                            favorites: []
                        },
                        authenticated: true
                    }
                });
                callback();
            });
    } catch (error) {
        dispatch({ type: UserActionType.AUTH_ERROR, payload: error.message });
    }
};

export const handleSignUpWithFacebook = (callback) => async dispatch => {
    const auth = firebase.auth
    const provider = new firebase.auth.FacebookAuthProvider()

    let newUser: any

    await auth().signInWithPopup(provider)
        .then((result) => {
            console.log(result.additionalUserInfo.isNewUser)
            let isNewUser = result.additionalUserInfo.isNewUser
            let user = result.user
            console.log(user)
            if (isNewUser) {
                console.log("if !!!!!!!!")
                Backend.database()
                    .ref('/users/' + user.uid)
                    .update({
                        name: user.displayName,
                        email: user.email,
                        photo: user.photoURL,
                        uid: user.uid,
                    });
                newUser = {
                    name: user.displayName,
                    email: user.email,
                    photo: user.photoURL,
                    uid: user.uid,
                    favorites: []
                }

                console.log(newUser , 'userfrom facebok')

                dispatch({
                    type: UserActionType.LOGIN,
                    payload: { authenticated: true, user: newUser }
                });
                callback();
            } else {
                Backend.database().ref('users/' + user.uid).on('value', (snapshot) => {
                    console.log(snapshot.val(), 'aaaaaaaaaa')
                    newUser = snapshot.val()
                    newUser.uid = user.uid
                    newUser.favorites = snapshot.val().favorites
                    newUser.facebook = snapshot.val().facebook ? snapshot.val().facebook : '',
                    newUser.instagram = snapshot.val().instagram ? snapshot.val().instagram : ''
                    newUser.website = snapshot.val().website ? snapshot.val().website : ''

                    dispatch({
                        type: UserActionType.LOGIN,
                        payload: { authenticated: true, user: newUser }
                    });
                    callback();
                    console.log('whaaaaaat')


                })
            }

        }).catch(error => {
            dispatch({ type: UserActionType.AUTH_ERROR, payload: error.message });
        });
};
//SIGNOUT
export const signout = callback => async dispatch => {
    Backend.auth()
        .signOut()
        .then(() => {
            console.log('logout')
            dispatch({
                type: UserActionType.LOGOUT,
                payload: { authenticated: false, user: null }
            });
            callback();
        })
        .catch(error => {
            dispatch({
                type: UserActionType.LOGOUT,
                payload: { authenticated: false, user: null }
            });
            dispatch({ type: UserActionType.AUTH_ERROR, payload: error.message });
            console.log('logout')

        });
};

//SIGN IN

export const signin = (formProps, callback) => async dispatch => {
    const { email, password } = formProps;
    let newUser
    try {
        const user = await Backend.auth().signInWithEmailAndPassword(
            email,
            password
        );
        Backend.database().ref('users/' + user.user.uid).on('value', (snapshot) => {
            newUser = snapshot.val()
            newUser.uid = user.user.uid
            newUser.favorites = snapshot.val().favorites
            newUser.facebook = snapshot.val().facebook ? snapshot.val().facebook : '',
            newUser.instagram = snapshot.val().instagram ? snapshot.val().instagram : ''
            newUser.website = snapshot.val().website ? snapshot.val().website : ''

            dispatch({ type: UserActionType.LOGIN, payload: { user: newUser, authenticated: true } });
            callback();
        })
    }
    catch (error) {
        console.log(error)
        dispatch({ type: UserActionType.AUTH_ERROR, payload: error.message + '/code: ' + Date.now() });
        console.log(error)
    }
};

export const checkSession = history => async dispatch => {
    Backend.auth().onAuthStateChanged(user => {
        if (user) {
            dispatch({
                type: UserActionType.LOGIN,
                payload: { user, authenticated: true, loading: false }
            });
            history.push('/userspace');
        } else {
            dispatch({
                type: UserActionType.AUTH_ERROR,
                payload: { user: null, authenticated: false, loading: false }
            });
            history.push('/');
        }
    });
};

//UPDATE PROFILE

export const update = (formProps, cb) => async dispatch => {
    const {
        userID,
        photoBlob,
        name,
        photo,
        email,
        facebook,
        instagram,
        website,
        changed } = formProps;
    console.log(formProps)
    try {
        changed ?
            (
                console.log('changed !!'),
                Backend.storage().ref('usersPics/' + userID).put(photoBlob)
                    .then(
                        res => {
                            console.log('ressss :', res)
                            res.ref.getDownloadURL().
                                then((downloadURL) => {
                                    console.log('photo URL: ', downloadURL)
                                    Backend.database()
                                        .ref('/users/' + userID)
                                        .update({
                                            name: name,
                                            email: email,
                                            photo: downloadURL,
                                            facebook: facebook ? facebook : '',
                                            instagram: instagram ? instagram : '',
                                            website: website ? website : ''
                                        })
                                    dispatch({
                                        type: UserActionType.UPDATE,
                                        payload: {
                                            user: {
                                                uid: userID,
                                                name: name,
                                                email: email,
                                                photo: downloadURL,
                                                facebook: facebook,
                                                instagram: instagram,
                                                website: website
                                            }
                                        }
                                    });
                                    cb()
                                })
                        }
                    )
            )
            :
            (
                console.log('didnt change !!'),
                Backend.database()
                    .ref('/users/' + userID)
                    .update({
                        name: name,
                        email: email,
                        facebook: facebook ? facebook : '',
                        instagram: instagram ? instagram : '',
                        website: website ? website : ''
                    }),
                dispatch({
                    type: UserActionType.UPDATE,
                    payload: {
                        user: {
                            uid: userID,
                            name: name,
                            email: email,
                            photo: photo,
                            facebook: facebook,
                            instagram: instagram,
                            website: website
                        }
                    }
                })
            )
    }
    catch (error) {
        console.log(error)
    }
};



// WEBPACK FOOTER //
// ./src/actions/userAction.tsx